
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[uuid]",
      function () {
        return require("private-next-pages/[uuid]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[uuid]"])
      });
    }
  